import { BenefitDTOBenefitEnum } from 'probonio-shared-ui/api';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { BenefitPaper } from '../../component/benefitTabs/BenefitPaper';
import { getBenefitIcon } from '../../module/benefits/BenefitIcon';
import BenefitSubPage from '../../module/benefits/BenefitSubPage';
import CarConnectPanel from '../../module/benefits/car/CarConnectPanel';
import { useCarPrecondition } from '../../module/benefits/car/useCarPrecondition';
import { AuthorizedLayout } from '../../module/navigation/AuthorizedLayout';

export const CarSettingsPage: React.FC = () => {
  const { t } = useTranslation('benefitsModule');
  const { isPreconditionMet, PreconditionComponent } = useCarPrecondition();

  return (
    <AuthorizedLayout title={t('CAR.settings.title')} breadcrumbs={[{ title: t('CAR.title'), to: '/benefits/car' }]}>
      <BenefitSubPage icon={getBenefitIcon(BenefitDTOBenefitEnum.Car)} title={t('CAR.title')} subTitle={t('CAR.settings.title')}>
        {isPreconditionMet ? (
          <BenefitPaper sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
            <CarConnectPanel />
          </BenefitPaper>
        ) : (
          <BenefitPaper>{PreconditionComponent}</BenefitPaper>
        )}
      </BenefitSubPage>
    </AuthorizedLayout>
  );
};

export default CarSettingsPage;
